import type { LayerItemType, PositionViewModel } from "../../../../models";

type GroupedItem = Pick<PositionViewModel, "key" | "displayFields">;

/**
 * The entity a position belongs to for coloring, paths and "Last Position Only". GetPositions keys a position by its
 * rep whenever one was logged in, so Machines layers group by the machine instead.
 */
export function positionGroupKey(itemType: LayerItemType | undefined, item: GroupedItem) {
	return (itemType === "Machines" && item.displayFields?.Machine) || item.key;
}

/**
 * Groups positions by their entity (rep/machine) and returns only the most
 * recent position for each group. Used by the "Last Position Only" filter.
 */
export function latestPositionPerGroup(
	positions: PositionViewModel[],
	groupKey: (position: PositionViewModel) => string = (position) => position.key,
): PositionViewModel[] {
	const latest = new Map<string, PositionViewModel>();
	for (const position of positions) {
		const key = groupKey(position);
		const existing = latest.get(key);
		if (!existing || new Date(position.date) > new Date(existing.date)) {
			latest.set(key, position);
		}
	}
	return Array.from(latest.values());
}
